/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Chancenrolemultiaspect4Inputs */

const de__filter_class_chancenrolemultiaspect4 = /** @type {(inputs: _Filter_Class_Chancenrolemultiaspect4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist eines von`)
};

/**

* @param {_Filter_Class_Chancenrolemultiaspect4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_chancenrolemultiaspect4 = /** @type {((inputs?: _Filter_Class_Chancenrolemultiaspect4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Chancenrolemultiaspect4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_class_chancenrolemultiaspect4(inputs)
});
export { _filter_class_chancenrolemultiaspect4 as "_filter_class_ChancenRoleMultiAspect" }